var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoProduct(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.6C3 3.72 3.72 3 4.6 3H17.4C17.8243 3 18.2313 3.16857 18.5314 3.46863C18.8314 3.76869 19 4.17565 19 4.6V6.2H3V4.6ZM3.8 7H18.2V17.4C18.2 17.8243 18.0314 18.2313 17.7314 18.5314C17.4313 18.8314 17.0243 19 16.6 19H5.4C4.97565 19 4.56869 18.8314 4.26863 18.5314C3.96857 18.2313 3.8 17.8243 3.8 17.4V7ZM8.6 8.6V10.2H13.4V8.6H8.6Z",
    fill: "#BBC1C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoProduct);
export default __webpack_public_path__ + "static/media/ico-product.565c9fc698792427206ddc1f707dae9e.svg";
export { ForwardRef as ReactComponent };